import "./Welcome.css";
import { useRef, useState, createContext, useEffect } from "react";
import { fromLonLat } from "ol/proj";
import MapWrapper from "../MapWrapper/";
import ScaleBar from "../ScaleBar/";
import MouseWatcher from "../MouseWatcher";
import Navbar from "../Navbar/";
import ResetZoom from "../ResetZoom";
import ResetRotation from "../ResetRotation/";
import GovFooterBar from "../GovFooterBar/";
import HorizontalToolbarToggler from "../HorizontalToolbarToggler/";
import { map, explorer } from "../../_config/map";

import LayerManager from "../LayerManager/LayerManagers";
import IAChatDialog from "../Verdian/verdian";



const LayerVisibleCountContext = createContext(1);

const Welcome = () => {
  const [visibleLayer, setVisibleLayer] = useState(0);

  const [currentLanguage, setCurrentLanguage] = useState("pt");

  const clientWidth = document.documentElement.clientWidth;

  const clientHeight = document.documentElement.clientHeight;

  const [darkMode, setDarkMode] = useState(false);

  const baseLayerRef = useRef(null);



  const handleDarkModeToggle = () => {
    setDarkMode(prev => !prev);

    if (!baseLayerRef.current) return;

    baseLayerRef.current.changeBaseLayer(
      !darkMode ? 'Mapa escuro' : 'Mapa topográfico'
    );
  };

  const handleBaseLayerChange = (title) => {
    const isDark = title === 'Mapa escuro';
    setDarkMode(isDark);
  };


  const hasNewVisibleLayer = (index) => {
    setVisibleLayer(index);
  };

  const handleLanguageChange = (language) => {
    setCurrentLanguage(language);
  };

  function flattenLayers(map) {
    const out = [];
    const walk = (lyr) => {
      const children = lyr.getLayers?.();
      if (children?.getArray) {
        children.getArray().forEach(walk);
      } else {
        out.push(lyr);
      }
    };
    map.getLayers().getArray().forEach(walk);
    return out;
  }

  function restoreFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const l = params.get("l"); // lista de names separados por vírgula
    const bbox = params.get("bbox"); // minx,miny,maxx,maxy (EPSG:3857)
    const z = params.get("z");
    const c = params.get("c"); // lon,lat (deg)
    const r = params.get("r");

    if (l) {
      const wanted = new Set(
        l
          .split(",")
          .map((s) => parseInt(s, 10))
          .filter((n) => Number.isFinite(n))
      );

      const flat = flattenLayers(map);
      flat.forEach((layer, i) => {
        if (wanted.has(i)) layer.setVisible(true);
      });
    }

    const view = map.getView();
    if (bbox) {
      const [minx, miny, maxx, maxy] = bbox.split(",").map(Number);
      view.fit([minx, miny, maxx, maxy], { size: map.getSize(), maxZoom: 18 });
    } else {
      if (c && z) {
        const [lon, lat] = c.split(",").map(Number);
        view.setCenter(fromLonLat([lon, lat], "EPSG:4326"));
        view.setZoom(Number(z));
      }
    }
    if (r) view.setRotation(Number(r));
  }

  useEffect(() => restoreFromUrl(), []);

  return (
    <div className="Welcome">
      <Navbar map={map} handleLanguageChange={handleLanguageChange} handleDarkModeToggle={handleDarkModeToggle} isDarkMode={darkMode} />

      <MapWrapper map={map}>
        <ScaleBar map={map} />
        <MouseWatcher map={map} />
        <ResetZoom map={map} />
        <ResetRotation map={map} />
        <HorizontalToolbarToggler map={map} onBaseLayerChange={handleBaseLayerChange} />
        {clientWidth > 900 && clientHeight > 750 ? (<LayerManager map={map}
          LayerVisibleCountContext={LayerVisibleCountContext} />
        ) : null}
      </MapWrapper>
      <GovFooterBar />
    </div>
  );
};

export default Welcome;
